import { EquipmentCategoryData } from "@/features/equipmentModels/types/equipmentCategories";
import { Forklift } from "lucide-react";

export class EquipmentCategoriesTransformer {
  static optionsTransformer() {
    return (equipmentCategories: EquipmentCategoryData[]) => {
      return equipmentCategories.map((equipmentCategory) => {
        return {
          value: equipmentCategory.id,
          label: equipmentCategory.display_name,
          icon: <Forklift strokeWidth={1} size={20} />
        };
      });
    };
  }
}
